import React, { useEffect, useState } from 'react';
import ApiServices from '../../services/apiservices';
import CustomSpinner from '../../components/customspinner';
import { useSelector } from 'react-redux';

export default function AdminDashboard() {
  const user = useSelector((state) => state.user.value);

    const [loading, setLoading] = useState(false);
    const [numUsers, setNumUsers] = useState()
    const [numPosts, setNumPosts] = useState()
    const [numopenJobs, setNumopenJobs] = useState()
    const [numnumclosedJobs, setNumclosedJobs] = useState()

  const fetchDashboardData =async()=> {
    try {
      setLoading(true);
      const res = await ApiServices.getRequest("/user/dashboard.php");        
      if (res.success) {
        setLoading(false);
        setNumUsers(res.numUsers)
        setNumPosts(res.numPosts)
        setNumopenJobs(res.numopenJobs)
        setNumclosedJobs(res.numclosedJobs)
      }
    } catch (err) {
      setLoading(true);
    } finally {
      
  }}

  useEffect(()=>{
    fetchDashboardData()
  }, [])
  return ( 
  <>{loading ? <CustomSpinner/> :<main className="flex-1 bg-white p-6 overflow-y-auto mt-4 lg:mt-0">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Dashboard Overview</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            
            { user.role === "systemadmin" || user.role ==='admin'
                   ?  <div className="p-4 bg-gray-100 rounded-lg shadow">
                   <h3 className="font-semibold text-gray-800">Users</h3>
                   <p className="text-3xl font-bold text-gray-900">{numUsers > 0 ? numUsers : 0}</p>
                 </div>:  " "
             
              }
  
            <div className="p-4 bg-gray-100 rounded-lg shadow">
              <h3 className="font-semibold text-gray-800">Total Posts</h3>
              <p className="text-3xl font-bold text-gray-900">{numPosts > 0 ? numPosts : 0}</p>
            </div>
            <div className="p-4 bg-gray-100 rounded-lg shadow">
              <h3 className="font-semibold text-gray-800">Open Jobs</h3>
              <p className="text-3xl font-bold text-gray-900">{numopenJobs > 0 ? numopenJobs : 0}</p>
            </div>

            <div className="p-4 bg-gray-100 rounded-lg shadow">
              <h3 className="font-semibold text-gray-800">Closed Jobs</h3>
              <p className="text-3xl font-bold text-gray-900">{numnumclosedJobs > 0 ? numnumclosedJobs :  0}</p>
            </div>
          </div>
        </main>
   }
       
</>        
  );
}

